import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import BlogPost from "../../components/blog/BlogPost";

const BlogPostPage: React.FC = () => {
  return (
    <>
      <Header />
      <BlogPost />
      <Footer />
    </>
  );
};

export default BlogPostPage;
